import React, { useEffect, useState } from "react";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import Pagination from "../../../../pagination/components/index";
import { useDispatch, useSelector } from "react-redux";
import { getUserList } from "../slice/userListingSlice";
import { useNavigate } from 'react-router-dom';
import "../style/userListing-style.css";
// import ClientFilter from "../../client-filter/components/index";

const UserListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { users, loading, error, pagination } = useSelector((state) => state.userList);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
      keyword: "",
      status: ""
    });

  useEffect(() => {
      dispatch(getUserList({ page, filters }));
    }, [dispatch, page, filters]);
  
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(1); 
  };

  const handleClearFilters = () => {
    setFilters({ keyword: "", status: "" });
    setPage(1);
  };

  console.log("users", users);
  // console.log("pagination", pagination);

  return (
    <>
      <div className="client-layout">
        {/* <ClientFilter
          filters={filters}
          onFilterChange={handleFilterChange}
          onClearFilters={handleClearFilters}
        /> */}
        <div className="client-listing">
          {users.map((user) => (
            <div key={user.id} className="client-card">
              <div className="client-photo-wrapper">
                <a href="#">
                  <img src={IC_logo} alt={user.name} className="client-photo" />
                </a>
              </div>
              <div className="client-details-main">
                <div className="client-details">
                  <a className="client_name" href="#">{user.name}</a><br />
                  <p> Email: {user.email}</p>
                  <p><button type="button" className="btn_view_proifile">View Profile</button></p>
                  {/* <p><button type="button" className="btn_chat" onClick={() => navigate(`/provider/chat/${user.id}`)}><i className="fa fa-comment px-1"></i> Chat</button></p> */}
                  <p>
                    {localStorage.getItem('provider_access_token') && (
                        <button
                        type="button"
                        className="btn_chat"
                        onClick={() => navigate(`/provider/chat/admin/${user.id}`)}
                        >
                        <i className="fa fa-comment px-1"></i> Chat
                        </button>
                    )}

                    {localStorage.getItem('client_access_token') && (
                        <button
                        type="button"
                        className="btn_chat"
                        onClick={() => navigate(`/chat/admin/${user.id}`)}
                        >
                        <i className="fa fa-comment px-1"></i> Chat
                        </button>
                    )}
                  </p>
                </div>
                <div className="send-request-block">
                  <button type="button" className="btn_send_request">Send Request</button>
                </div>
              </div>
            </div>
          ))}
          <Pagination
        currentPage={page}
        totalPages={pagination.last_page || 0}
        onPageChange={handlePageChange}
      />
        </div>
        
      </div>
      
    </>
  );
};

export default UserListing;